// external
import { useCallback } from "react";

// api
import apiRoot from "api/apiRoot";

/**
 * Custom hook for admit adjustment API calls
 * Separates API logic from data transformation logic
 */
const useAdmitAdjustmentApi = () => {
  /**
   * Fetches need rank ranges for a school
   */
  const fetchNeedRanks = useCallback(async (schoolKey) => {
    const response = await apiRoot.get("/api/fao-admit-adjustment/need-ranks", {
      params: { schoolKey },
    });
    return response.data;
  }, []);

  /**
   * Fetches admit adjustment data for a model
   */
  const fetchAdmitAdjustmentData = useCallback(async (modelId) => {
    const response = await apiRoot.get("/api/fao-admit-adjustment/data", {
      params: { modelId },
    });
    return response.data;
  }, []);

  /**
   * Fetches both need ranks and admit adjustment data in parallel
   */
  const fetchAllData = useCallback(async (schoolKey, modelId) => {
    const [needRanksResponse, admitAdjustmentResponse] = await Promise.all([
      fetchNeedRanks(schoolKey),
      fetchAdmitAdjustmentData(modelId),
    ]);

    return {
      needRanks: needRanksResponse,
      admitAdjustmentData: admitAdjustmentResponse,
    };
  }, [fetchNeedRanks, fetchAdmitAdjustmentData]);

  return {
    fetchNeedRanks,
    fetchAdmitAdjustmentData,
    fetchAllData,
  };
};

export default useAdmitAdjustmentApi; 